// used in pdp , plp , related , upsell etc
export const StoreAttributes = `
  is_bulk_product,
  subtitle
  is_custom_kit
  is_bundle_options_hidden
`
